import {createSlice, type PayloadAction} from '@reduxjs/toolkit';

interface FavoritesStoreState {
  favorites: string[];
}

export const initialState: FavoritesStoreState = {
  favorites: [],
};

export const favoritesSlice = createSlice({
  name: 'favorites',
  initialState,
  reducers: {
    initFavorites: (state, action: PayloadAction<string[]>) => {
      state.favorites = action.payload;
    },
    favoriteTemplate: (state, action: PayloadAction<{name: string}>) => {
      const {name} = action.payload;

      let favorites = [...state.favorites];
      if (!favorites.includes(name)) {
        favorites.push(name);
        if (window.favoritesNumber !== undefined) window.favoritesNumber++;
      } else {
        favorites = favorites.filter((fav) => fav !== name);
        if (window.favoritesNumber !== undefined) window.favoritesNumber--;
      }

      state.favorites = favorites;
    },
  },
  selectors: {
    selectFavorites: (state) => state.favorites,
  },
});

export const favoritesReducer = favoritesSlice.reducer;
export const {initFavorites, favoriteTemplate} = favoritesSlice.actions;
export const {selectFavorites} = favoritesSlice.selectors;
